<template>
  <div class="animated fadeIn">
    <br>
    <div class="sk-circle" v-if="show_spinner">
      <div class="sk-circle1 sk-child"></div>
      <div class="sk-circle2 sk-child"></div>
      <div class="sk-circle3 sk-child"></div>
      <div class="sk-circle4 sk-child"></div>
      <div class="sk-circle5 sk-child"></div>
      <div class="sk-circle6 sk-child"></div>
      <div class="sk-circle7 sk-child"></div>
      <div class="sk-circle8 sk-child"></div>
      <div class="sk-circle9 sk-child"></div>
      <div class="sk-circle10 sk-child"></div>
      <div class="sk-circle11 sk-child"></div>
      <div class="sk-circle12 sk-child"></div>
    </div>
    <div class="row" v-else="">
      <div class="col-md-4 push-4">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <h4><strong>NO ES TROBEN ELEMENTS</strong></h4>
            </div>
            <div class="row">
              &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;Vol recarregar la pagina?
            </div>
            <br>
            <div class="row">
              &emsp;&emsp;&emsp;&emsp;&emsp;
              &emsp;&emsp;&emsp;&emsp;&emsp;
              <button type="button" class="btn btn-primary" @click="reloadPage()">
                <i class="icon-reload"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        show_spinner: true
      }
    },
    created() {
      var out = this;
      setTimeout(
        function () {
          out.show_spinner = false;
        }, 7500
      );
    },
    methods:{
      reloadPage(){
        location.reload();
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// GeneralSpinner.vue?c5bce306